import * as moment from 'moment';

export class Transfer {
    id: number;
    date: moment.Moment;
    from: string;
    to: string;
    value: string;
    playerId: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/transfer.model.ts